import { ContentItem } from '@kentico/kontent-delivery';

export class FactAboutUs extends ContentItem {     
}